import RequestException from '@/exception/requestException';
import { isNotUserRejectRequest } from '@/utils/wagmi';

export default function useErrorHandler() {
  return function getErrorMessage(error: any) {
    if (isNotUserRejectRequest(error) && !(error instanceof RequestException)) {
      const msg = error.message;
      window.$message?.error(msg);
    }
  };
}
